import { Component, Input } from "@angular/core";

@Component({
  selector: "app-earnings-footer",
  templateUrl: "./earnings-footer.component.html",
})
export class EarningsFooterComponent {
  @Input() footerDescription!: string;
}
